import { FC, ReactNode } from 'react'
import { ReactComponent as SparkleIcon } from 'src/assets/svg/ai-badge-sparkle.svg'
import { ReactComponent as InfoIcon } from 'src/assets/svg/ri-information-fill.svg'
import styles from './createProjectModalFooter.module.scss'

interface CreateProjectModalFooterProps {
  customLeftContent?: ReactNode
  footerNote?: string
  isNextDisabled?: boolean
  leftButtonLabel?: string
  onLeftButtonClick: () => void
  onNext: () => void
  rightButtonLabel?: string
  showCreateIcon?: boolean
  widePrimaryButton?: boolean
}

export const CreateProjectModalFooter: FC<CreateProjectModalFooterProps> = ({
  customLeftContent,
  footerNote,
  isNextDisabled = false,
  leftButtonLabel = 'Cancel',
  onLeftButtonClick,
  onNext,
  rightButtonLabel = 'Next',
  widePrimaryButton = false,
  showCreateIcon = false,
}) => {
  return (
    <div className={styles.footerRow}>
      {customLeftContent ? (
        customLeftContent
      ) : footerNote ? (
        <div className={styles.footerNote}>
          <InfoIcon className={styles.footerNoteIcon} />
          <span>{footerNote}</span>
        </div>
      ) : null}

      <div className={styles.footerActions}>
        <button
          className={styles.cancelButton}
          onClick={onLeftButtonClick}
          type="button"
        >
          {leftButtonLabel}
        </button>

        <button
          className={`${styles.nextButton} ${
            showCreateIcon ? styles.createButton : ''
          } ${widePrimaryButton ? styles.wideButton : ''}`}
          disabled={isNextDisabled}
          onClick={onNext}
          type="button"
        >
          {showCreateIcon ? (
            <SparkleIcon className={styles.createIcon} />
          ) : null}
          {rightButtonLabel}
        </button>
      </div>
    </div>
  )
}
